import { render } from "./EditPremium.vue?vue&type=template&id=38a809bd&scoped=true"
import script from "./EditPremium.vue?vue&type=script&lang=js"
export * from "./EditPremium.vue?vue&type=script&lang=js"

import "./EditPremium.vue?vue&type=style&index=0&id=38a809bd&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a809bd"]])

export default __exports__